import React from 'react';
import { Check } from 'lucide-react';
import './ButtonValidar.css';

const ButtonValidar = ({ onClick, disabled }) => {
    return (
        <button className="boton-validar" onClick={onClick} disabled={disabled} title="Validar">
            <Check />
        </button>
    );
};

export default ButtonValidar;